const parametrizationIncrementSupplierHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false
      }
    ]
  },
  {
    group: 'Loja',
    columns: [
      {
        name: 'Id',
        id: 'loja-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'loja-nome',
        show: true
      }
    ]
  },
  {
    group: 'Produto',
    columns: [
      {
        name: 'Id',
        id: 'produto-id',
        show: true
      },
      {
        name: 'Nome',
        id: 'produto-nome',
        show: true
      }
    ]
  },
  {
    group: 'Data',
    columns: [
      {
        name: 'Inicio',
        id: 'data-inicio',
        show: true
      },
      {
        name: 'Fim',
        id: 'data-fim',
        show: true
      }
    ]
  },
  {
    group: 'Incremento',
    columns: [
      {
        name: 'Estoque Dias',
        id: 'incremento-estoque-dias',
        show: true,
        isNumeric: true
      },
      {
        name: 'Estoque Unidade',
        id: 'incremento-estoque',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Configuração',
    columns: [
      {
        name: 'Nome',
        id: 'usuario',
        show: true
      },
      {
        name: 'Data',
        id: 'criado',
        show: true
      },
      {
        name: 'Observação',
        id: 'obersevation',
        show: true
      }
    ]
  }
]

export default parametrizationIncrementSupplierHeader
